import { defineStore } from 'pinia';

interface FormState {
  formState: { value: string };
}

export const useFormsStore = defineStore('forms', {
  state: () => ({
    activeForms: {} as Record<string, FormState>,
  }),
  getters: {
    isAnyEditedForm(state): boolean {
      return Object.values(state.activeForms).filter(({ formState }) => formState.value !== 'idle').length > 0;
    },
  },
  actions: {
    storeFormState({ formName, state: formState }: { formName: string; state: { value: string } }) {
      const { value } = formState;
      this.activeForms[formName] = { formState: { value } };
    },
    deleteFormState(formName: string) {
      if (this.activeForms[formName]) {
        delete this.activeForms[formName];
      }
    },
  },
});
